import {gsap} from 'gsap'
import 'pace-js'
import {runIntroAnimations} from '../animations/intro'
import Lottie from 'lottie-web'

let pageLoaded = false
let animationFinished = false
let animationIsPlaying = false
let preloaderLottie = null
let animation = null
let paceLagCounter = 10
let preloaderAnimationExecuted = 0
window.onbeforeunload = renderLoading;

function renderLoading() {
  Pace.stop();
  //Pace.start();
  Pace.bar.render();
}

setTimeout(function () {
  // Bugfix for too fast loading (browser cache)
  if (Pace.bar.progress >= 100 || Pace.bar.progress === 0) {
    const rndInt = Math.floor(Math.random() * (39 - 10 + 1) + 10)
    paceUpdate(rndInt)
  }
}, 50)

function runPreloaderAnimation() {
  if (preloaderAnimationExecuted) {
    return false
  }
  if (!pageLoaded || !animationFinished) {
    return false
  }

  preloaderAnimationExecuted = 1;

  setTimeout(function () {
    gsap.fromTo('#preloader', {
      yPercent: 0
    }, {
      yPercent: -100,
      duration: 1,
      onComplete: () => {

        // $('#preloader').hide();
        setTimeout(() => {
          runIntroAnimations();
        }, 750);
      }
    })
  }, 200)

  setTimeout(function () {
    runIntroAnimations()
  }, 750)

  preloaderAnimationExecuted = 1;

}


function setupLottie(preloaderLottie) {
  let path = preloaderLottie.attr('data-animation-path')
  let introId = 'preloader-animation'

  let svgContainer = document.getElementById(introId)

  const LOTTIE_TIMEOUT = 2300;
  let lottieTimeoutId = setTimeout(() => {
    animationFinished = true;
    runPreloaderAnimation();
  }, LOTTIE_TIMEOUT);

  animation = Lottie.loadAnimation({
    container: svgContainer,
    animType: 'svg',
    loop: false,
    autoplay: true,
    path: path
  });

  animation.addEventListener('complete', () => {
    clearTimeout(lottieTimeoutId);
    animationFinished = true;
    runPreloaderAnimation();
  });

  animation.addEventListener('error', (error) => {
    clearTimeout(lottieTimeoutId);
    animationFinished = true;
    runPreloaderAnimation();
  });
}

Pace.bar.update = function (progress) {
  Pace.trigger('update', progress)
  this.progress = progress;
  return this.render();
} // override update func to trigger 'update' event

function paceUpdate(percent) {
  if (!preloaderLottie) {
    preloaderLottie = $('#preloader-animation')
    setupLottie(preloaderLottie)
  }

  if (percent > 40 && !animationIsPlaying && preloaderLottie) {
    $('.preloader-logo').css('opacity', 1)
    animationIsPlaying = true
    animation.play()
  }

  if (percent > 10) {
    $('.js-percentage').html(Math.ceil(percent) + ' %')
  }

  if (percent > 99) {
    paceLagCounter -= 1
    if (paceLagCounter <= 0) {
      Pace.stop()
      pageLoaded = true
      runPreloaderAnimation()
    }
  }
}

Pace.on("update", function (percent) {
  paceUpdate(percent)
});

Pace.on('done', function () {
  $('.js-percentage').html('100 %');
  pageLoaded = true;
  runPreloaderAnimation();
})

Pace.start()

